import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3a4b7be8"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=3a4b7be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/Users/tdrdimov/gogoproj/fitapp - current GIT/fitnhealthy/src/components/Logo.vue').default,Header: require('/Users/tdrdimov/gogoproj/fitapp - current GIT/fitnhealthy/src/components/Header.vue').default,Footer: require('/Users/tdrdimov/gogoproj/fitapp - current GIT/fitnhealthy/src/components/Footer.vue').default})
